export class UserSearchModel{
    officeTypeId:number;
    officeId:number;
}